const host = process.env.REACT_APP_BASE_URL;
const port = process.env.REACT_APP_PORT_IMG;
const version = process.env.REACT_APP_BASE_VERSION;
export const BASE_URL_PREVIEW_IMG = `${host}${port}${version}/own/images/preview`